import React from 'react';

import { SplitDescriptions } from '../../../components/SplitDescriptions';
import { UnitDetailsFragment, usegetUnitDetailsQuery } from '../../../graphql/hasura/generated';
import createDetailsLayout from '../../../layouts/createDetailsLayout';
import { getPropertyFeatureFlags } from '../../../utils';
import { createdAtAndByColumn, updatedAtColumn } from '../../common/columns';
import * as columns from '../columns';

const UnitDetailsLayout = createDetailsLayout<UnitDetailsFragment>();

export const UnitDetailsPage: React.FC<any> = () => {
  return (
    <UnitDetailsLayout
      modelName='Unit'
      useQuery={(unitId) => {
        return usegetUnitDetailsQuery({
          variables: { unitId },
        });
      }}
      body={(unit) => {
        const featureFlags = getPropertyFeatureFlags(unit.property);

        return (
          <SplitDescriptions
            row={unit}
            leftSideColumns={[
              columns.propertyColumn,
              columns.unitNumberColumn,
              columns.buildingColumn,
              columns.occupancyColumn,
              columns.typeColumn,
              createdAtAndByColumn,
              updatedAtColumn,
            ]}
            rightSideColumns={[
              unit.sourceId ? columns.sourceIdColumn : null,
              columns.unitGroupColumn,
              columns.smartLocksColumn,
              featureFlags.VIRTUAL_DIRECTORY ? columns.virtualDirectoryStatusColumn : null,
            ]}
          />
        );
      }}
    />
  );
};

export default UnitDetailsPage;
